import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { LoaderService } from './loader.service';

export const SKIP_LOADER_HEADER = 'X-Skip-Loader';

@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptorService implements HttpInterceptor {
  private activeRequests = 0;

  constructor(private loaderService: LoaderService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.headers.has(SKIP_LOADER_HEADER)) {
      return next.handle(request.clone({ headers: request.headers.delete(SKIP_LOADER_HEADER) }));
    }

    this.activeRequests++;
    this.loaderService.show();

    return next.handle(request).pipe(finalize(() => {
      this.activeRequests--;
      if (this.activeRequests === 0) {
        this.loaderService.hide();
      }
    }));
  }
}
